<template>
  <v-card width="380"
    :class="`!flex flex-col px-10 py-5 ${planData.name.toLowerCase()}_color border-0 rounded-xl rounded-tl-0 rounded-br-0 !text-black`">
    <v-card-title class="!font-Handel px-0 !text-2xl font-weight-bold !tracking-wider">
      <v-col class="!m-0 pa-0 !max-w-fit ">
        <v-icon left large color="black" dark> mdi-shield-crown </v-icon>
      </v-col>
      <v-col class="!m-0 pa-0 ">
        <span class="break-normal capitalize">
          {{ planData.name }} package
        </span>
      </v-col>
    </v-card-title>
    <v-card-subtitle class="!font-Handel !text-black !text-3xl px-0 mt-3">
      $ {{ planData.amount }}
      <span class="!text-lg black--text">Monthly</span>
    </v-card-subtitle>
    <div class="">
      <div class="text-left flex flex-col !text-base font-bold !font-Nunito overflow-auto h-72">
        <div class="my-2">
          <v-icon left size="20" class="black--text">
            mdi-shield-check-outline
          </v-icon>
          Free Spotify
        </div>
        <div class="my-2">
          <v-icon left size="20" class="black--text">
            mdi-shield-check-outline
          </v-icon>
          Unlimited Images Upload
        </div>
        <div class="my-2">
          <v-icon left size="20" class="black--text">
            mdi-shield-check-outline
          </v-icon>
          Free Voice Call
        </div>
        <div class="my-2">
          <v-icon left size="20" class="black--text">
            mdi-shield-check-outline
          </v-icon>
          Free Video Call
        </div>
        <div class="my-2">
          <v-icon left size="20" class="black--text">
            mdi-shield-check-outline
          </v-icon>
          Cancel anytime
        </div>
      </div>
    </div>
    <v-btn color="black" large elevation="0" outlined class="my-5 mt-auto font-Handel" dark :disabled="checkUserPlan"
      @click.prevent="subscribeHandler(planData)">
      <v-icon class="mr-2" color="black"> mdi-shield-crown-outline </v-icon>
      Subscribe Now
    </v-btn>
  </v-card>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    planData: {
      type: Object,
    },
  },
  data() {
    return {
      btnDisabled :false,
    }
  },
  computed : {
    checkUserPlan(){
      if(this.planData.name == this.$store.getters.StateUser.data.plan_name){
        return true
      }else{
        return false
      }
    }
  },

  methods: {
    
    subscribeHandler(id) {
      this.$emit('addPaymentModalShow')
      this.$store.dispatch('getSelectedId', id)
    }
  },
  created() {
    
  },
};
</script>
<style scoped>
.basic_color {
  background: rgb(177, 145, 65);
  background: linear-gradient(345deg,
      rgb(97 69 0) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(90 64 0 / 97%) 100%);
}

.premium_color {
  background: rgb(126, 0, 157);
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
}

.Silver_color {

  background: linear-gradient(344deg, rgb(78 84 94) 0%, rgb(246 246 246) 51%, rgb(84 101 125) 100%)
}
</style>
